import type { ReactNode } from 'react'

interface StatusScreenProps {
  title: string
  message?: string | undefined
  children?: ReactNode
}

// Полноэкранный статус вместо контента страницы — терминальные состояния
// (вход, недоступная задача, битая ссылка), где тост мимолётен.
export function StatusScreen({ title, message, children }: StatusScreenProps) {
  return (
    <section className="container-x flex flex-col items-center justify-center gap-6 px-6 pt-safe-24 pb-safe-24 text-center">
      <div className="flex flex-col items-center gap-2">
        <h1 className="t-h2 text-text-primary">{title}</h1>
        {message && <p className="text-text-secondary">{message}</p>}
      </div>
      {children && <div className="flex flex-wrap justify-center gap-3">{children}</div>}
    </section>
  )
}
